import { ReactNode } from "react";
import classnames from "classnames";
import { KeyValue } from "../../lib/keyboard";
import { CharStatus } from "../../lib/statuses";

type Props = {
  children?: ReactNode;
  value: KeyValue;
  status?: CharStatus;
  onClick: (value: KeyValue) => void;
};

export const Key = ({
  children,
  status,
  value,
  onClick,
}: Props) => {
  const isWide = value === "ENTER" || value === "DELETE";

  const classes = classnames("key", {
    "key-wide": isWide,
    "key-correct": status === "correct",
    "key-present": status === "present",
    "key-absent": status === "absent",
  });

  return (
    <button
      className={classes}
      onClick={() => onClick(value)}
      style={isWide ? { maxWidth: '65px', flex: '1.5' } : undefined}
    >
      {children || value}
    </button>
  );
};
